<template>
  <v-card height="250px">
    <v-container fluid>
      <v-row no-gutters>
        <v-col>
          <h2 class="title">Porcentaje de equipos en servicio taller</h2>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col>
          <highcharts :options="chartOptions"></highcharts>
        </v-col>
      </v-row>
      <v-row class="lift-card">
        <v-col cols="7"> </v-col>
        <v-col cols="5">
          <div class="objetivo text-center">Objetivo 10%</div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  mounted() {
    if (this.$route.params.branchOffice) {
      this.getPercentageMachinesInService(this.$route.params.branchOffice);
    } else {
      this.getPercentageMachinesInService();
    }
  },
  computed: {
    ...mapState("machines", [
      "productsInServicePercentage",
      "productsInService",
      "chartOptions"
    ])
  },
  methods: {
    ...mapActions("machines", ["getPercentageMachinesInService"])
  },
  watch: {
    "$route.params.branchOffice": {
      handler: function(branch) {
        if (branch) {
          this.getPercentageMachinesInService(branch);
        } else {
          this.getPercentageMachinesInService();
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style lang="css" scoped>
.title {
  font-weight: 400 !important;
  color: black;
  font-size: 16px !important;
}
</style>
<style lang="css">
.highcharts-axis-labels.highcharts-yaxis-labels {
  display: none;
}
.lift-card {
  margin-top: -55px !important;
  z-index: 1000;
}
.objetivo {
  background-color: #f5f5f5;
  color: #808080;
  font-weight: 400;
  font-size: 14px;
}
</style>
